export const Urls = {
    GetSharedAccessSignatureToken: "api/v1/RightShipAttachment/GetSharedAccessSignatureToken",
    GetSharedAccessSignatureTokenFromPath: "api/v1/RightShipAttachment/GetSharedAccessSignatureTokenFromPath",
    RightShipAttachment: "api/v1/RightShipAttachment",
    DeleteCorrespondenceAttachments: "api/v1/RightShipAttachment/rsDeleteCorrespondence",
    GetAttachments: "api/v1/RightShipAttachment/getAttachments"
}